/**
 * In-memory access token store.
 * Access tokens must not be persisted in localStorage (XSS-readable).
 * Session restore uses the HttpOnly refresh cookie via auth-service.
 */

let accessToken: string | null = null

export function getAccessToken(): string | null {
  return accessToken
}

export function setAccessToken(token: string | null): void {
  accessToken = token
}

export function clearAccessToken(): void {
  accessToken = null
}

/** Bearer header value, or empty string if no token. */
export function getAccessTokenBearer(): string {
  return accessToken ? `Bearer ${accessToken}` : ''
}
